import { ASIA, ASEAN, INDONESIA, MEKONG, AUSTRALIA, CHINA, INDIA, JAPAN, KOREA, TAIWAN, USA, PACIFIC } from '@shared/constants';
import {
  USA_STATE,
  CHINA_PROVINCE,
  ASIA as ASIA_MAP,
  ASIA_PACIFIC,
  JAPAN as JAPAN_MAP,
  SOUTH_KOREA,
  AUSTRALIA as AUSTRALIA_MAP,
  INDIA as INDIA_MAP,
  TAIWAN as TAIWAN_MAP,
  PACIFIC as PACIFIC_MAP,
} from '@shared/components/charts/regionalMapChart/regionalMapChart.constants';

export const MAP_REGIONS = {
  [ASIA]: ASIA_PACIFIC,
  [ASEAN]: ASIA_MAP,
  [PACIFIC]: PACIFIC_MAP,
  [INDONESIA]: ASIA_MAP,
  [MEKONG]: ASIA_MAP,
  [AUSTRALIA]: AUSTRALIA_MAP,
  [CHINA]: CHINA_PROVINCE,
  [INDIA]: INDIA_MAP,
  [JAPAN]: JAPAN_MAP,
  [KOREA]: SOUTH_KOREA,
  [TAIWAN]: TAIWAN_MAP,
  [USA]: USA_STATE,
  [PACIFIC]: PACIFIC_MAP,
};

export const STROKE_WIDTH = 0.5;
export const SELECTED_STROKE_WIDTH = 1;
